export default [
    {
      path: '/admin/inventory/unit-of-measures',
      name: 'unit-of-measure',
      meta: { requiresAuth: true },
      component: () => import('@/pages/inventory/uom/index.vue')
    }
  ]
